import { Link } from "react-router-dom";
import RlLogo from "../../components/rl-logo/RlLogo";
import { PAGE_PATH } from "../../path";

type RlLogoProps = {
  productName: string;
  linksReloadDocument: boolean;
  longLogo?: boolean;
  width?: string;
};

const RlHeaderLogo = ({
  productName = "",
  linksReloadDocument,
  longLogo,
  width
}: RlLogoProps) => (
  <Link
    id="rl-logo"
    className="rl-logo"
    to={PAGE_PATH.SEARCH}
    title={productName}
    reloadDocument={linksReloadDocument}
  >
    <RlLogo
      variant={longLogo ? "long" : "short"}
      className={"rl-logo__image"}
      width={width ?? "112px"}
      alt={productName}
    />
  </Link>
);

export default RlHeaderLogo;
